export default __webpack_public_path__ + "static/media/brandLogoNewMobileNegative.46b54669.svg";